import { Table } from '@rd-web-markets/shared/dist/util';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { SHOW_REGULAR_REALTIME_DASHBOARD } from '@rd-web-markets/market/dist/constants';
export default function DashboardsTable(_ref) {
  let {
    claimGroupsOrCompanies,
    tableHeader = 'claim_group'
  } = _ref;
  const {
    t
  } = useTranslation();
  const user = useSelector(state => state.auth.user);
  const getDashboardLink = object => {
    if (SHOW_REGULAR_REALTIME_DASHBOARD && object.dashboard_type === 'business_unit_intensity_breakdown') {
      return "/".concat(user.account_type, "/regular_realtime_dashboard/").concat(object.id);
    } else {
      return "/".concat(user.account_type, "/dashboard/").concat(object.id);
    }
  };
  const headers = [{
    text: t(tableHeader)
  }, {
    text: t('dashboard')
  }];
  const rows = claimGroupsOrCompanies.map(object => ({
    columns: [object.name, /*#__PURE__*/React.createElement("a", {
      href: getDashboardLink(object)
    }, t('view_dashboard'))]
  }));
  return /*#__PURE__*/React.createElement(Table, {
    headers: headers,
    rows: rows,
    showControls: false
  });
}